import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAngle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 4L4 20H20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 20C12 15.5817 8.41828 12 4 12",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1954 5.7186L20.914 5.02318L19.5232 3.58598L18.8046 4.2814L20.1954 5.7186ZM4.69542 20.7186L5.47042 19.9686L4.07958 18.5314L3.30458 19.2814L4.69542 20.7186ZM7.02042 18.4686L8.57042 16.9686L7.17958 15.5314L5.62958 17.0314L7.02042 18.4686ZM10.1204 15.4686L11.6704 13.9686L10.2796 12.5314L8.72958 14.0314L10.1204 15.4686ZM13.2204 12.4686L14.7704 10.9686L13.3796 9.5314L11.8296 11.0314L13.2204 12.4686ZM16.3204 9.4686L17.8704 7.9686L16.4796 6.5314L14.9296 8.0314L16.3204 9.4686ZM19.4204 6.4686L20.1954 5.7186L18.8046 4.2814L18.0296 5.0314L19.4204 6.4686Z",
			fill: "currentColor"
		})
	]
});
export default SvgAngle;
